import React from 'react'

export default function DarkPoint() {
  return (
    <div className='h-10 max-[1140px]:h-8 max-[1140px]:w-8 rounded-lg max-[992px]:h-6 max-[992px]:w-6 max-[992px]:rounded-md  w-10 border-2 border-white'></div>
  )
}
